import { Injectable } from '@angular/core';
import { DataService } from 'src/app/core/data.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TermsAndConditionsService {

  constructor(private dataService: DataService) { }

  //Api to get the user's terms and conditions based on UserId
  getTermsAndConditionIdByUserId(userId:string) : Observable<any>{
   return this.dataService.getRequest("User/GetTermsAndConditionsIdByUserId?userId="+userId);
  }

  //An Api call to get the user's terms and conditions content
  getTermsandConditions(termsAndConditionId:string) : Observable<any>{
     return this.dataService.getRequest("termsandconditions/GetTermsandConditions?termsAndConditionId="+termsAndConditionId);
   }

   //An Api call to update the accepted T&C id to the corresponding User Account
   putRequestToUpdateTermsAndConditionId(updateUserAccount:any){
     return this.dataService.putRequest("User/UpdateTermsAndConditionId",updateUserAccount)
  }

  //API response to get Terms and Conditions by id.
  public getTermsandConditionsById(Id: string): Observable<any> {
    return this.dataService.getRequest('termsandconditions/GetTermsandConditionsById?=' + Id);
  }
}
